import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Layout from '../../Layout/Layout'
import AiLeadsAction from '../../AiLeads/AiLeadsButton/AiLeadsAction'
import Loader from '../../Loader/Loader'
import * as XLSX from 'xlsx';
import axios from "axios";
import { toast } from "react-toastify";
import { APISalesforceUrl, APIDataUrl, APITokenUrl, GetUserId } from "../../../Utils/Utils";
import OrganizationSearchResultsTable from './OrganizationSearchResultsTable'
import DeepSearchSelectionModal from '../../UniversalDeepSearch/DeepSearchSelectionModal'
const OrganizationSearchResults = () => {
    const [loading, setLoading] = useState(false)
    const location = useLocation()
    const [archiveRecord, setArchiveRecord] = React.useState(false)
    const [trackRecord, setTrackRecord] = React.useState(false)
    const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
    const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
    const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
    const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
    const [showSalesForce, setShowSalesForce] = useState(false)
    const [showLeadsProspects, setShowLeadsProspects] = useState("")
    const [selectedProspectsInner, setSelectedProspectsInner] = React.useState([]);
    // for organization tracking 
    const [trackingData, setTrackingData] = useState([]);
    const [disableTracking, setDisableTracking] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([])
    const [totalCount, setTotalCount] = React.useState(0)
    const [addToFav, setAddToFav] = useState(false)
    //Universal Deep Search
    const [openSelectionModal, setOpenSelectionModal] = useState(false)
    useEffect(() => {
        localStorage.removeItem("cns")
        localStorage.removeItem("cip")
        localStorage.removeItem("cdp")
    }, [])
    const exportToExcel = (data, filename) => {
        const filteredData = data.map(
            ({ person_id, org_id, strengthData, ...rest }) => rest
        );
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `${filename}.xlsx`);
        setIsDecisionMakerExcel(false);
    };
    React.useEffect(() => {
        if (isDecisionMakerExcel) {
            if (selectedLeads?.length) {
                exportToExcel(selectedLeads, 'leads_exported_data');
            } else {
                toast.error("Please select records to download excel.")
            }
        }
        setIsDecisionMakerExcel(false)
    }, [isDecisionMakerExcel])
    useEffect(() => {
        if (selectedProspectsInner?.length) {
            setShowLeadsProspects("pros")
        } else if (selectedLeads?.length) {
            setShowLeadsProspects("leads")
        } else {
            setShowLeadsProspects("")
        }
    }, [selectedLeads, selectedProspectsInner])
    const handleTrackingdata = () => {
        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APITokenUrl(),
            },
            url: `${APIDataUrl()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                const data = e?.data?.data;
                setTrackingData(data)
            })
            .catch((err) => { });
    };
    useEffect(() => {
        handleTrackingdata();
    }, []);
    useEffect(() => {
        if (trackingData.length > 0 && selectedLeads.length > 0) {
            const isMatching = trackingData.some((trackingItem) =>
                selectedLeads.every(
                    (selectedItem) => Number(selectedItem.org_id) === Number(trackingItem.org_id)
                )
            );
            setDisableTracking(isMatching);
        } else {
            setDisableTracking(false);
        }
    }, [trackingData, selectedLeads]);
    return (
        <>
            <Layout>
                {loading ? <Loader /> : null}
                <div className="child-section-of-everypage  ">
                    <div style={{ display: "flex" }}>
                        <div>
                            <AiLeadsAction
                                disableTracking={disableTracking}
                                setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                                setIsSalesForceTrigger={setIsSalesForceTrigger}
                                isSalesForceTrigger={isSalesForceTrigger}
                                archiveRecord={archiveRecord}
                                setArchiveRecord={setArchiveRecord}
                                setTrackRecord={setTrackRecord}
                                setAddToFav={setAddToFav}
                                disableRequestUpdate={disableRequestUpdate}
                                setRequestUpdateRecord={setRequestUpdateRecord}
                                showSalesForce={showSalesForce} />
                        </div>
                    </div>
                    <div style={{ padding: "60px 0px 10px 4px" }}>
                        <p className='psr-block'>
                            Below is a list of organizations  related to your search inquiry
                        </p>
                        <p className='psr-block-red'>
                            Unable to find an organization or prospect? <span onClick={() => setOpenSelectionModal(true)}>Click Here to do a Deep Search</span>
                        </p>
                    </div>
                    <div className='psr-block-red psr-records'>Showing {totalCount} results</div>
                    <h3 className='psr-head'>Organizations</h3>
                    <OrganizationSearchResultsTable
                        handleTrackingdata={handleTrackingdata}
                        trackingData={trackingData}
                        loading={loading}
                        setLoading={setLoading}
                        isSalesForceTrigger={isSalesForceTrigger}
                        setIsSalesForceTrigger={setIsSalesForceTrigger}
                        isDecisionMakerExcel={isDecisionMakerExcel}
                        setIsDecisionMakerExcel={setIsDecisionMakerExcel}
                        archiveRecord={archiveRecord}
                        setArchiveRecord={setArchiveRecord}
                        trackRecord={trackRecord} setTrackRecord={setTrackRecord}
                        selectedOuterRows={selectedLeads}
                        setSelectedOuterRows={setSelectedLeads}
                        setShowSalesForce={setShowSalesForce}
                        showLeadsProspects={showLeadsProspects}
                        selectedRows={selectedProspectsInner}
                        requestUpdateRecord={requestUpdateRecord}
                        setRequestUpdateRecord={setRequestUpdateRecord}
                        setDisableRequestUpdate={setDisableRequestUpdate}
                        setSelectedRows={setSelectedProspectsInner}
                        totalCount={totalCount} setTotalCount={setTotalCount}
                        addToFav={addToFav} setAddToFav={setAddToFav} />
                </div>
            </Layout>
            <DeepSearchSelectionModal openSelectionModal={openSelectionModal} setOpenSelectionModal={setOpenSelectionModal} setLoading={setLoading} />
        </>
    )
}
export default OrganizationSearchResults